const DocumentSideItems = ({ arr }) => {
  return arr.map((i) => {
    return (
      <li className="document-side-item" key={i.id} id={i.id}>
        {i.name}
      </li>
    );
  });
};
export default DocumentSideItems;
